export const FILTERS_API_URL =
	"/wp-admin/admin-ajax.php?action=ytk_service_feed_filters";
export const POSTS_API_URL = "/wp-admin/admin-ajax.php?action=ytk_service_feed";
